import { render, staticRenderFns } from "./slider-cmp-extended.vue?vue&type=template&id=51dad6a0&scoped=true"
import script from "./slider-cmp-extended.vue?vue&type=script&lang=js"
export * from "./slider-cmp-extended.vue?vue&type=script&lang=js"
import style0 from "./slider-cmp-extended.vue?vue&type=style&index=0&id=51dad6a0&prod&lang=scss"
import style1 from "./slider-cmp-extended.vue?vue&type=style&index=1&id=51dad6a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51dad6a0",
  null
  
)

export default component.exports